import { persistStorageService } from '@/features/auth/persist-storage';
import axios, { AxiosError } from 'axios';

export const createApiClient = ({
  baseURL,
  timeout,
  headers,
  withCredentials,
}: {
  baseURL: string;
  timeout: number;
  headers: Record<string, string>;
  withCredentials: boolean;
}) =>
  axios.create({
    baseURL,
    timeout: timeout || 50000,
    headers: headers
      ? {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...headers,
        }
      : {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
    withCredentials: withCredentials || false,
  });

export const axiosErrorHandler = async (error: AxiosError) => {
  console.log('🚨 Error [ API CLIENT ]', error);
  if (error.response?.data) {
    console.log('🚨 Error [ AXIOS ]', {
      error: error.response.data,
      code: error.response.status,
    });
    const message = error.response.data as string;
    const code = error.response.status;
    return Promise.reject({ message, code, status: code });
  }
  return Promise.reject(error);
};
